<template>
  <div class="mobile_header">
    <div class="block_heade"></div>
    <div class="wrap_img">
      <van-image width="110"  :src="logoImg" class="logo_style"/>
      <van-popup v-model="show" position="right" :style="{ width:'120px',height: '100%' }">
        <ul>
          <li v-for="(item,index) in actions" :key="index" class="li_text" :class="index===Number(indexInit)?'active':''" @click="btnRightJump(item)">{{item.text}}</li>
        </ul>
      </van-popup>
      <van-image width="30" height="20" style="margin-top:25px" :src="logoImgMore" @click="btnRight" />

      <!-- <van-popover 
  v-model="showPopover"
  trigger="click"
  :actions="actions"
  @select="onSelect"
  placement="bottom-end"
>
  <template #reference>
    <van-image width="30" height="20" style="margin-top:25px" :src="logoImgMore" />
  </template>
</van-popover> -->


      
    </div>
  </div>
</template>

<script>
export default {
  name: "mobileHeader",
  props: {
    indexInit: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      // logoImg: require("@/assets/imgs/logo-active.png"),
      logoImg: require("@/assets/imgs/logo.png"),
      logoImgMore: require("@/assets/mobileImg/more.png"),
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: "首页", url: "home" },
        { text: "直播", url: "shootvideo" },
        { text: "短视频", url: "shortvideo" },
        // { text: "服务项目", url: "business" },
        { text: "商业视频", url: "bussvideo" },
        { text: "视频课程", url: "videocourse" },
        { text: "多媒体展示", url: "multimedia" },
        { text: "案例展示", url: "casepage" },
        { text: "关于我们", url: "aboutus" }],
      show:false,
      // activeIndex:0,
    };
  },
  mounted() {},
  methods: {
    onSelect(action) {
      Toast(action.text);
    },
    btnRight() {
      this.show = !this.show
    },
    btnRightJump(item){
      document.documentElement.scrollTop = 0;
      this.$router.push({
        name: item.url
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_header{
  position: relative;
  .block_heade{
    position: absolute;
    width: 100%;
    height: 3px;
    background: #e91d62;
    bottom: -1px;
    left: 0;
    z-index: 3;
  }
  .wrap_img{
    width: 100%;
    height: 70px;
    background: #e91d62;
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  /deep/.logo_style img.van-image__img{
    height: auto;
  }
  .li_text{
    width: 120px;
    height: 50px;
    line-height: 50px;
    font-size:14px;
    color:#333;
    text-align: center;
  }
  .active{
    background: #e91d62;
    color:white
  }

}
</style>



